.priceTableValue {
  font-family: var(--font-roboto-mono);
}
